import React from 'react';

import { TextField } from '@occc-app/design-system';

interface ISegmentFormContentProps {
  readOnly: boolean;
  editMode: boolean;
  disabled?: boolean;
}

export const SegmentFormContent: React.FC<ISegmentFormContentProps> = ({
  readOnly,
  editMode,
  disabled,
}) => {
  return (
    <>
      <TextField
        name='name'
        label='Name'
        disabled={disabled}
        InputProps={{ readOnly }}
        margin='normal'
      />
      <TextField
        name='shortCode'
        label='Short Code'
        disabled={disabled ?? editMode}
        InputProps={{ readOnly }}
        margin='normal'
      />
      <TextField
        name='description'
        label='Description'
        disabled={disabled}
        multiline={true}
        InputProps={{ readOnly }}
        margin='normal'
      />
    </>
  );
};
